import styleguide from '@common/styleguide';
import { FC } from 'react';
import { IconSVG, IconSVGComponentProps } from '../IconComponent';

// This is an especially custom icon: colors are hardcoded. Be careful with
// how / where this is used to ensure it renders as expected.
export const SharedBlend: FC<IconSVGComponentProps> = (props) => {
    return (
        <IconSVG stroke="0" {...props}>
            <g clipPath="url(#clip0_20_132)">
                <circle
                    cx="8.34782"
                    cy="8.34782"
                    r="8.34782"
                    fill={styleguide.colors.blue}
                />
                <g style={{ mixBlendMode: 'multiply' }}>
                    <circle
                        cx="15.6523"
                        cy="15.6523"
                        r="8.34782"
                        fill={styleguide.colors.orangeBright}
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_20_132">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </IconSVG>
    );
};
